import React from 'react'

import {getCarrierLabel} from '../../../server/functions/parcels/carrierLabel.js'

export {getCarrierLabel}

export default class CarrierLogo extends React.Component {
    render() {
        const {size = 45, carriers, value, options, style, disabled} = this.props

        const carrier = carriers.find((carrier) => carrier.name === value) || {logo: ''}

        if (!carriers) {
            if (value === 'DHL') {
                carrier.logo = '/images/dhlLogo.png'
            }

            if (value === 'DHL Europlus') {
                carrier.logo = '/images/dhlEuroplusLogo.png'
            }

            if (value === 'PostNL') {
                carrier.logo = '/images/postnlLogo.png'
            }
        }

        return (
            <img
                style={{
                    objectFit: 'contain',
                    height: size,
                    maxWidth: 2 * size,
                    filter: disabled ? 'grayscale(1)' : 'none',
                    ...style
                }}
                src={getCarrierLabel(carrier, options).logo}
            />
        )
    }
}
